import React, { useEffect, useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import AsyncSelect from "react-select/async";

import Swal from "sweetalert2";
// import CreateFacilityTypeReq from 'Classes/Models/Requests/Administration/CreateFacilityTypeReq';
import UsersApi from "../../../Classes/API/UsersApi";
import SessionsApi from "../../../Classes/API/Administration/SessionsApi";
import searchSessionsReq from "../../../Classes/Models/Requests/Administration/CreateSessionReq";
import searchUsersReq from "../../../Classes/Models/Requests/Users/SearchUser";
import UserTypes from "../../../Classes/Models/Requests/Users/UserTypes";
import CreatePackageReq0 from "../../../Classes/Models/Requests/AccountingSessions/CreatePackageReq";

const CreatePackage = ({ setCreatedNewPackage }) => {
  const [SessionsSearch, setSessionsSearch] = useState();
  const [Session, setSession] = useState({});

  const [PatientsSearch, setPatientsSearch] = useState();
  const [Patient, setPatient] = useState({});

  const [PackageName, setPackageName] = useState("");
  const [Quantity, setQuantity] = useState("");
  const [IsPaidFor, setIsPaidFor] = useState(false);
  const [OriginalPrice, setOriginalPrice] = useState("");
  const [Discount, setDiscount] = useState("");

  const [ErrorText, setErrorText] = useState(false);
  const [SuccessText, setSuccessText] = useState("");

  useEffect(() => {
    if (Object.keys(Session).length > 0 && Object.keys(Patient).length > 0) {
      GetOriginalPrice();
    }
  }, [Session, Patient]);

  const GetSessions = async () => {
    let searchReq = new searchSessionsReq();

    searchReq.Name = SessionsSearch; // search by name
    if (Object.keys(Patient).length < 1) {
      Swal.fire({
        title: "Error",
        text: "Please select a patient first",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }
    searchReq.ContractId =
      Object.keys(Patient.getPatient).length > 0 && Patient.getPatient.contractId;
    searchReq.IsContractSession =
      Object.keys(Patient.getPatient).length > 0 && Patient.getPatient.contractId ? true : false;

    console.log(searchReq);

    let res = await SessionsApi.SearchSessions(searchReq);

    if (res.status == "Success") {
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({ value: item, label: item.name });
      });
      return optionsArr;
    }
  };

  const GetPatients = async () => {
    let searchReq = new searchUsersReq();
    let userTypes = new UserTypes();

    searchReq.name = PatientsSearch;
    // searchReq.number = PatientsSearch;
    // searchReq.email = PatientsSearch;
    searchReq.userType = userTypes.Patient;
    let res = await UsersApi.SearchUsers(searchReq);

    if (res.status == "Success") {
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({ value: item, label: item.name });
      });
      return optionsArr;
    }
  };

  const GetOriginalPrice = () => {
    if (Patient.nationalityGroup == "Egyptian") {
      setOriginalPrice(Session.egyptianPrice);
    } else if (Patient.nationalityGroup == "Arab") {
      setOriginalPrice(Session.arabPrice);
    } else if (Patient.nationalityGroup == "Other") {
      setOriginalPrice(Session.otherPrice);
    } else {
      setOriginalPrice("PRICE NOT FOUND");
    }
  };

  const ShowPricing = () => {
    if (Object.keys(Session).length > 0 && Object.keys(Patient).length > 0) {
      return (
        <MDBox mt={4} mb={1}>
          <MDTypography variant="button" fontWeight="regular" color="text">
            Patient Nationality Group: {Patient.nationalityGroup}, Original Price: {OriginalPrice}{" "}
            EGP
          </MDTypography>
          <MDInput
            type={"number"}
            onChange={(e) => setDiscount(e.target.value)}
            label={"Discount %"}
          ></MDInput>
        </MDBox>
      );
    }
  };

  const onSubmit = async () => {
    if (!PackageName) {
      setErrorText(true);
      return;
    }

    let req = new CreatePackageReq0();

    req.discount = Discount;
    req.isPaidFor = IsPaidFor;
    req.originalPrice = OriginalPrice;
    req.sessionId = Session.id;
    req.patientId = Patient.getPatient.id;
    req.packageName = PackageName;
    req.quantity = Quantity;
    req.metaSession.patientId = Patient.getPatient.id;
    req.metaSession.sessionId = Session.id;
    req.metaSession.isPaidFor = IsPaidFor;

    let res = await SessionsApi.CreatePackage(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Package Created Successfully",
        icon: "success",
        confirmButtonText: "OK",
      });
      setCreatedNewPackage(true);
    } else {
      Swal.fire({
        title: "Error",
        text: "Something went wrong",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <Card mb={3} id="CreatePackageCard" className="mb-5">
      <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDButton onClick={() => onSubmit()} variant="gradient" color="dark">
          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
          &nbsp;Add New Package
        </MDButton>
      </MDBox>
      <form id="CreatePackageForm">
        <MDBox p={3}>
          <MDBox
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            p={3}
            sx={{
              border: ({ borders: { borderWidth, borderColor } }) =>
                `${borderWidth[1]} solid ${borderColor}`,
            }}
          >
            <div className="col-md-4">
              <MDTypography variant="button" fontWeight="regular" color="text">
                Select Session:
                <AsyncSelect
                  isClearable={true}
                  loadOptions={GetSessions}
                  onInputChange={setSessionsSearch}
                  onChange={(e) => setSession(e ? e.value : "")}
                  // value={TypeId}
                />
              </MDTypography>
            </div>

            <div className="col-md-4">
              <MDTypography variant="button" fontWeight="regular" color="text">
                Select Patient:
                <AsyncSelect
                  isClearable={true}
                  loadOptions={GetPatients}
                  onInputChange={setPatientsSearch}
                  onChange={(e) => setPatient(e ? e.value : "")}
                  // value={TypeId}
                />
              </MDTypography>
            </div>

            <MDBox mt={4} mb={1}>
              {ShowPricing()}
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDInput
                type={"text"}
                onChange={(e) => setPackageName(e.target.value)}
                label={"Notes"}
              ></MDInput>

              <MDInput
                type={"number"}
                onChange={(e) => setQuantity(e.target.value)}
                label={"Quantity"}
              ></MDInput>
            </MDBox>
          </MDBox>
          {!PackageName && ErrorText == true && (
            <small
              className="alert alert-danger font-sm mt-4 mx-0 text-right d-block col-md-12"
              role="alert"
            >
              {" "}
              برجاء إدخال إسم الباكدج{" "}
            </small>
          )}
        </MDBox>
      </form>
    </Card>
  );
};

export default CreatePackage;
